import { ConfigType } from 'dayjs';

import { formatTime } from 'method';
import { MOMENT_FORMAT } from 'constants/formats';
import {
  XlsxColumn,
  PLATFORM_STATUS,
  PLATFORM_STATUS_MAP,
} from './index';
import { CONTENT } from 'constants/content';

export const skuLisKey = ['sku_id', 'sku_name', 'price', 'quantity', 'item_sku', 'variation_sku'];

export const formatTimeDisplay = (time: ConfigType) => {
  return formatTime(time, MOMENT_FORMAT.YMD_DASH_HM_COLON);
};
export const formatPlatformStatus = (status: PLATFORM_STATUS) => {
  return PLATFORM_STATUS_MAP[status] || '';
};
export const formatPrice = (price: number) => {
  return Math.ceil(price);
};

export const orderFieldExportOptions: XlsxColumn[] = [
  {
    key: 'buyer_address',
    label: '買家地址',
  },
  {
    key: 'buyer_name',
    label: '買家姓名',
  },
  {
    key: 'buyer_phone',
    label: '買家電話',
  },
  {
    key: 'create_time',
    label: '訂單成立時間',
  },
  {
    key: 'days_to_ship',
    label: '備貨天數',
  },
  {
    key: 'message_to_seller',
    label: '買家備註',
  },
  {
    key: 'pay_time',
    label: '訂單付款時間',
  },
  {
    key: 'platform_status',
    label: '出貨訂單狀態名稱',
  },
  {
    key: 'ship_by_date',
    label: '出貨期限',
  },
  {
    key: 'shipping_carrier',
    label: '物流選項',
  },
  {
    key: 'shop_id',
    label: 'Shop ID',
  },
  {
    key: 'shop_name',
    label: '蝦皮商店名稱',
  },
  {
    key: 'sku_list',
    label: '商品清單',
  },
  {
    key: 'supplier_id',
    label: CONTENT.SUPPLIER_ID,
  },
  {
    key: 'supplier_name',
    label: CONTENT.SUPPLIER_NAME,
  },
  {
    key: 'logistics_name',
    label: '物流選項',
  },
  {
    key: 'logistics_number',
    label: CONTENT.TRACKING_NO,
  },
  {
    key: 'tracking_no',
    label: `${CONTENT.TRACKING_NO}`,
  },
];


export const returnFieldExportOptions: XlsxColumn[] = [
  {
    key: 'supplier_id',
    label: CONTENT.SUPPLIER_ID,
  },
  {
    key: 'supplier_name',
    label: CONTENT.SUPPLIER_NAME,
  },
  {
    key: 'create_time',
    label: '訂單成立時間',
  },
  {
    key: 'platform_status',
    label: '出貨訂單狀態名稱',
  },
  {
    key: 'shop_id',
    label: 'Shop ID',
  },
  {
    key: 'shop_name',
    label: '蝦皮商店名稱',
  },
  {
    key: 'pickup_name',
    label: '取貨人姓名',
  },
  {
    key: 'pickup_phone',
    label: '取貨人電話',
  },
  {
    key: 'pickup_zipcode',
    label: '取貨郵遞區號',
  },
  {
    key: 'pickup_address',
    label: '取貨地址',
  },
  {
    key: 'sku_id',
    label: '商品 ID',
  },
  {
    key: 'sku_name',
    label: '商品名稱',
  },
  {
    key: 'quantity',
    label: '數量',
  },
  {
    key: 'price',
    label: '單價',
  },
  {
    key: 'reason',
    label: '退貨原因',
  },
  {
    key: 'text_reason',
    label: '退貨詳情',
  },
  {
    key: 'logistics_name',
    label: '物流選項',
  },
  {
    key: 'logistics_number',
    label: CONTENT.TRACKING_NO,
  },
];

export const allFieldLabels: Record<string, string> = [
  ...orderFieldExportOptions,
  ...returnFieldExportOptions,
].reduce((acc, { key, label }) => {
  if (typeof key === 'string') {
    acc[key] = label;
  }
  return acc;
}, {} as Record<string, string>);

